import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
// @mui
import { Box } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
// import { useSettingsContext } from '../../components/settings';
//
import Main from './Main';
import DashboardParamHeader from './header';
import { NAV } from '../../config-global';
import NavHorizontal from './nav/NavHorizontal';
// ----------------------------------------------------------------------

export default function DashboardParamLayout() {
    //   const { themeLayout } = useSettingsContext();
    const isDesktop = useResponsive('up', 'lg');

    const IsFullScreen = useSelector(state => state.screen.fullScreenVale);
    const [open, setOpen] = useState(true);
    const [navWidth, setNavWidth] = useState(NAV.W_DASHBOARD);

    const handleOpen = () => {
        setOpen(true);
        setNavWidth(NAV.W_DASHBOARD);
    };

    const handleClose = () => {
        setOpen(false);
        setNavWidth(0);
    };

    //   const renderNavVertical = <JJMINavbar openNav={open} onCloseNav={handleClose} />;

    return (
        <>
            {!IsFullScreen && <DashboardParamHeader openNav={open} onOpenNav={handleOpen} navWidth={navWidth} />}

            {/*  {isDesktop ? <NavHorizontal /> : null} */}
            <NavHorizontal />

            <Box
                sx={{
                    display: { lg: 'flex' },
                    minHeight: { lg: 1 },
                    // mt: 10
                    mt: 7
                }}
            >
                <Main>
                    <Outlet />
                </Main>
            </Box>
        </>
    );
}
